import React, { useState, useEffect } from 'react';

const Quote = () => {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    company: '',
    days: '3',
    attendees: '',
    tin: '',
    notes: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (!form.fullName || !form.email || !form.company || !form.attendees) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setError('Please fill in all required fields.');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      const apiUrl = import.meta.env.PROD ? 'https://africa-maritime-talent.onrender.com' : 'http://localhost:5002';
      const res = await fetch(`${apiUrl}/api/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (!res.ok) {
        const j = await res.json();
        throw new Error(j.message || 'Failed to generate quote');
      }
      const refNumber = res.headers.get('X-Reference-Number');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'quote.pdf';
      link.click();
      window.URL.revokeObjectURL(url);
      alert(`Quote downloaded and emailed to you.\nReference No: ${refNumber || 'N/A'}`);
      setForm({ fullName: '', email: '', company: '', days: '3', attendees: '', tin: '', notes: '' });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  // Set up the background pattern
  useEffect(() => {
    document.body.style.background = 'url(\'/patterns/AMC_Green Pattern Two-8.png\') center/cover no-repeat fixed';
    document.body.style.backgroundColor = '#f0f9ff';
    document.body.style.backgroundBlendMode = 'overlay';
    document.body.style.backgroundAttachment = 'fixed';
    
    return () => {
      // Restore default body styles when component unmounts
      document.body.style.background = '';
      document.body.style.backgroundColor = '';
      document.body.style.backgroundBlendMode = '';
      document.body.style.backgroundAttachment = '';
    };
  }, []);

  return (
    <div className="min-h-screen relative">
      <section className="relative z-10 pt-32 pb-16 px-4 sm:px-6 lg:px-8 flex items-start justify-center min-h-screen">
        <div className="w-full max-w-3xl bg-white/95 shadow-2xl rounded-2xl p-10 border border-white/60">
      <h1 className="text-4xl font-extrabold mb-2 text-center text-primary-navy">Request a Quote</h1>
        <p className="text-center text-gray-600 mb-8">Fill in the form below and we'll instantly generate a detailed PDF quotation for your team.</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Full Name *</label>
          <input name="fullName" value={form.fullName} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Email Address *</label>
          <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Company *</label>
          <input name="company" value={form.company} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Number of Days *</label>
          <select name="days" value={form.days} onChange={handleChange} className="w-full border px-3 py-2 rounded">
            <option value="3">Full 3 Days</option>
          </select>
            <p className="text-sm text-gray-600 mt-1">{form.days === '3' ? 'Full Access (3 days) – USD 1500 per attendee. There will be 10% discount for multiple attendees' : '2 Days – USD 1000 per attendee. There will be 10% discount for multiple attendees'}</p>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Number of Attendees *</label>
          <input type="number" name="attendees" min="1" value={form.attendees} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">TIN Number (optional)</label>
          <input name="tin" value={form.tin} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Additional Notes (optional)</label>
          <textarea name="notes" rows="4" value={form.notes} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
        </div>
        {error && <p className="text-red-600">{error}</p>}
        <button type="submit" disabled={submitting} className="w-full bg-gradient-to-r from-primary-navy to-primary-blue text-white py-3 rounded-lg shadow hover:opacity-90 disabled:opacity-50 transition-all">
          {submitting ? 'Generating...' : 'Download Quote'}
        </button>
      </form>
        </div>
      </section>
    </div>
  );
};

export default Quote;
